import { faChartPyramid } from '@fortawesome/pro-regular-svg-icons';
import { faBuildingShield, faShieldVirus, faSwords } from '@fortawesome/pro-duotone-svg-icons';

import { RoleProps } from './skills-matrix.types';

export const ROLE_OPTIONS: RoleProps[] = [
  { id: 'foundational', label: 'Foundational', value: 'foundational', icon: faChartPyramid },
  { id: 'analyst', label: 'Security Analyst', value: 'analyst', icon: faSwords },
  { id: 'penetration', label: 'Penetration Tester', value: 'penetration', icon: faBuildingShield },
  { id: 'engineer', label: 'Security Engineer', value: 'engineer', icon: faShieldVirus },
];
